export enum ProjectView {
  Assess,
  Visualize,
  Design
}
